import TopNav from '@/components/TopNav.vue'
import BottomNav from '@/components/BottomNav.vue'
import Social from '@/helpers/social.vue'

export default {
  components: {
    TopNav,
    BottomNav,
    Social
  },

  data () {
    return {
      colors: {
        visit: '#c21f25',
        exhibitions: '#fe0000',
        programs: '#f47b1f',
        collection: '#f6cb27',
        library: '#c8cc26',
        learn: '#68cce8',
        support: '#6876e8',
        about: '#939598'
      }
    }
  },

  watch: {
    loading: function () {
      if (!this.loading && this.key !== 'search' && this.key !== 'home' && this.key !== 'upcoming' && this.key) {
        document.title = 'CAAM | ' + this.loadedData[this.key].content.title
      } else if (this.key === 'search') {
        document.title = 'CAAM | Search'
      } else {
        document.title = 'CAAM | California African American Museum'
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/mixins/ComponentMixin.js